import { toCamelCase } from 'util/string-transform';

export const workOrderUrlPrefix = 'work-orders';
export const workOrderQueryKey = toCamelCase(workOrderUrlPrefix);
